(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      var filter_toolbar = document.body;
      filter_toolbar.classList.remove('sticky-toolbar');
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      var headerElement = document.querySelector('.light_logo');
      var headerElement1 = document.querySelector('.header');
      var headerHeight = headerElement1.offsetHeight;
      
      if (headerElement && headerElement.classList.contains('show_logo')) {
       headerElement1.classList.remove('header-light');
      }

      var filter_toolbar = document.body;
      filter_toolbar.classList.add('sticky-toolbar');
      var position_top = document.querySelector('.toolbar-pfs');
      position_top.style.top = headerHeight+'px';
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      var headerElement = document.querySelector('.light_logo');
      var headerElement1 = document.querySelector('.header');
      
      if (headerElement && headerElement.classList.contains('show_logo')) {
       headerElement1.classList.add('header-light');
      }
      var filter_toolbar = document.body;
      filter_toolbar.classList.remove('sticky-toolbar');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  // Manage the back button case 
  document.addEventListener('DOMContentLoaded', function () {
    const backBtn = document.getElementById('back-btn');

    backBtn.addEventListener('click', function (e) {
      e.preventDefault(); // stops page reload

      // clear popup state
      localStorage.removeItem('popopen');

      // go back
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/'; // fallback
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300))
  }
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  (function() {
    const form = document.querySelector('form[action*="account"]');
    const submitBtn = document.getElementById('resetSubmit');
    if (!form || !submitBtn) return;

    var passwordInput = document.getElementById('password');
    var confirmInput = document.getElementById('password_confirmation');
    var errorEl = document.getElementById('password-error');
    alert(errorEl);
    if (!passwordInput || !confirmInput || !errorEl) return;

    var rules = {
      length: {
        el: document.getElementById('req-length'),
        test: function(v) { return v.length >= 12; }
      },
      upper: {
        el: document.getElementById('req-upper'),
        test: function(v) { return /[A-Z]/.test(v); }
      },
      lower: {
        el: document.getElementById('req-lower'),
        test: function(v) { return /[a-z]/.test(v); }
      },
      digit: {
        el: document.getElementById('req-digit'),
        test: function(v) { return /\d/.test(v); }
      },
      symbol: {
        el: document.getElementById('req-symbol'),
        test: function(v) { return /[^A-Za-z0-9]/.test(v); }
      },
      match: {
        el: document.getElementById('req-match'),
        test: function(v) { return v === confirmInput.value && v.length > 0; }
      }
    };

    function updateChecklist() {
      var value = passwordInput.value;

      Object.keys(rules).forEach(function(key) {
        var rule = rules[key];
        if (!rule.el) return;

        if (rule.test(value)) {
          rule.el.style.color = 'green';
        } else {
          rule.el.style.color = 'inherit';
        }
      });
    }

    passwordInput.addEventListener('input', function() {
      updateChecklist();
      errorEl.style.display = 'none';
    });

    confirmInput.addEventListener('input', function() {
      updateChecklist();
      errorEl.style.display = 'none';
    });

    submitBtn.addEventListener('click', function(e) {
      var value = passwordInput.value;
      // alert(value);
      // return;
      var failed = Object.keys(rules).filter(function(key) {
        return !rules[key].test(value);
      });

      var passwordsMatch = value === confirmInput.value;
      
      if (failed.length > 0 || !passwordsMatch) {
        e.preventDefault();
        errorEl.textContent = errorEl.dataset.errorMessage;
        errorEl.style.display = 'block';
      }
      form.submit(); // ✅ Shopify-safe submit
    });
  })();
});

  } catch(e) { console.error(e); }
})();
})();
